export default function offerImageOptionsResolver({ offer, itemSettings, offerSettings }) {
    return {
        bind: {
            offer,
            settings: itemSettings,
            mobile: offerSettings.mobile,
            vertical: offerSettings.vertical,
            isAdult: offerSettings.isAdult,
        },
    };
}
